<nova-detail-toolbar title="{{notificationsTitle}}" [showBackButton]="false" [template]="toolbarTemplate">
    <ng-template #toolbarTemplate>
        @if (aspNetUserId === currentUserId) {
            <button mat-icon-button (click)="openPreferencesFlyout()"
                matTooltip="Preferences" matTooltipPosition="above" data-qa-id="InAppNotificationsPreferencesGear">
                <mat-icon>settings</mat-icon>
            </button>
        }
    </ng-template>
</nova-detail-toolbar>
<!-- AN-31480 - animations are disabled f or this mat-tab-group to prevent a bug when switching between tabs too quickly -->
<!-- https://github.com/angular/components/issues/10938#issuecomment-432744152 -->
<mat-tab-group #tabsTag [@.disabled]="true" [selectedIndex]="selectedTabIndex" (selectedTabChange)="onSelectedTabChange($event)" mat-stretch-tabs="false">
    <!-- all mat-tab instances here should be lazy loaded - https://material.angular.io/components/tabs/overview#lazy-loading -->
    <mat-tab [label]="getTabLabel(InAppNotificationType.Tasks)">
        <ng-template matTabContent>
            <nova-in-app-notifications-list
                [parentInAppNotificationTypeId]="InAppNotificationType.Tasks" [inAppNotificationUser]="user"></nova-in-app-notifications-list>
        </ng-template>
    </mat-tab>
    @if (enableInAppNotificationsTickets) {
        <mat-tab [label]="getTabLabel(InAppNotificationType.Tickets)">
            <ng-template matTabContent>
                <nova-in-app-notifications-list
                    [parentInAppNotificationTypeId]="InAppNotificationType.Tickets"></nova-in-app-notifications-list>
            </ng-template>
        </mat-tab>
    }
    @if (showAMLiveListNotifications) {
        <mat-tab [label]="getTabLabel(InAppNotificationType.AMLiveList)">
            <ng-template matTabContent>
                <nova-in-app-notifications-list
                    [parentInAppNotificationTypeId]="InAppNotificationType.AMLiveList"></nova-in-app-notifications-list>
            </ng-template>
        </mat-tab>
    }
    <mat-tab [label]="getTabLabel(InAppNotificationType.Jobs)">
        <ng-template matTabContent>
            <nova-in-app-notifications-list
                [parentInAppNotificationTypeId]="InAppNotificationType.Jobs"></nova-in-app-notifications-list>
        </ng-template>
    </mat-tab>
    @if (enableComplianceListNotifications) {
        <mat-tab [label]="getTabLabel(InAppNotificationType.Compliance)">
            <ng-template matTabContent>
                <nova-in-app-notifications-list
                    [parentInAppNotificationTypeId]="InAppNotificationType.Compliance"></nova-in-app-notifications-list>
            </ng-template>
        </mat-tab>
    }
</mat-tab-group>
